/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

export default function InviteUsersSuccessDialog({ successDialog, onToggleSuccessDialog }) {
  const { t } = useTranslation();

  return (
    <Dialog data-testid="invite-success-dialog" open={successDialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <DialogStatus variant="success" />
        <Typography component="h2" variant="h2">
          {t('user-management.invite.members.success.dialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>{t('user-management.invite.members.success.dialog.description')}</DialogContent>
      <DialogActions>
        <Button
          data-testid="go-to-org-btn"
          onClick={() => {
            onToggleSuccessDialog(false);
          }}
          color="primary"
        >
          {t('user-management.go.to.org')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
